import React, { PureComponent } from 'react';
import { Button, Paper, FormWrapper, Select, Input } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { ReactComponent as IconFileUpload } from 'svg/file-upload-solid.svg';
import Dropzone from 'react-dropzone';

import { TRANSMISSION_REPORT_TYPES } from 'constants/transmissionTypes';
import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import s from './styles.module.scss';

const titleSizes = {
  xs: 4,
};

const contentSizes = {
  xs: 8,
  lg: 6,
};

const contentSizesDeviceParams = {
  md: 12,
  lg: 8,
};

const titleSizesDeviceParams = {
  xs: 12,
  md: 12,
  sm: 12,
  lg: 4,
};

class UploadTransmissionReport extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    parsePdf: PropTypes.func.isRequired,
    newReportNextStep: PropTypes.func.isRequired,
    deviceVendor: PropTypes.string.isRequired,
    transmissionType: PropTypes.string.isRequired,
    setTransmissionType: PropTypes.func.isRequired,
    unscheduledVisitReason: PropTypes.string,
    setUnscheduledVisitReason: PropTypes.func.isRequired,
  };

  static defaultProps = {
    unscheduledVisitReason: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
  }

  onDropAccepted = files => {
    const { parsePdf } = this.props;
    const [file] = files;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      this.setState({ dragAndDropError: null });
      this.setState({ files: [{ name: file.name, base64: event.target.result }] });
      parsePdf({ file });
    };
  };

  onDropRejected = () => {
    this.setState({ dragAndDropError: 'reports.dragAndDropErrorOnlyPdf' });
  };

  onHandlerSubmit = () => {
    const { newReportNextStep } = this.props;
    newReportNextStep();
  };

  render() {
    const {
      t,
      deviceVendor,
      transmissionType,
      setTransmissionType,
      unscheduledVisitReason,
      setUnscheduledVisitReason,
    } = this.props;
    const { files, dragAndDropError } = this.state;
    return (
      <Paper>
        <FormWrapper title={t('reports.deviceTransmissionReport')}>
          <AdaptiveDataRow
            withLabelMargin
            titleSizes={titleSizes}
            contentSizes={contentSizes}
            title={t('reports.deviceVendor')}
          >
            <div className={s.textValue}>{deviceVendor}</div>
          </AdaptiveDataRow>
          <AdaptiveDataRow
            withLabelMargin
            titleSizes={titleSizesDeviceParams}
            contentSizes={contentSizesDeviceParams}
            title={t('reports.transmissionType')}
          >
            <Select
              placeholder={t('reports.transmissionTypePlaceholder')}
              value={transmissionType}
              onChange={({ target: { value } }) => setTransmissionType(value)}
            >
              {TRANSMISSION_REPORT_TYPES.map(item => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </Select>
          </AdaptiveDataRow>
          {transmissionType.match(/Unscheduled|Non/gi) && (
            <AdaptiveDataRow
              withLabelMargin
              titleSizes={titleSizesDeviceParams}
              contentSizes={contentSizesDeviceParams}
              title={t('reports.unscheduledVisitReason')}
            >
              <Input
                value={unscheduledVisitReason}
                onChange={({ target: { value } }) => setUnscheduledVisitReason(value)}
              />
            </AdaptiveDataRow>
          )}
          <AdaptiveDataRow
            titleSizes={titleSizesDeviceParams}
            contentSizes={contentSizesDeviceParams}
            title={t('reports.fullTransmissionReport')}
          >
            <Dropzone
              onDropAccepted={this.onDropAccepted}
              onDropRejected={this.onDropRejected}
              accept="application/pdf"
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div
                    {...getRootProps({ className: `dropzone ${s.dropzone}` })}
                    data-test="dropZone"
                  >
                    <input {...getInputProps()} />
                    <p>{t('reports.dragAndDropReport')}.</p>
                  </div>
                  <aside>
                    {dragAndDropError && <div className={s.fieldError}>{t(dragAndDropError)}</div>}
                    {files.map(({ name }) => (
                      <p key={name}>{name}</p>
                    ))}
                  </aside>
                </section>
              )}
            </Dropzone>
            <Button
              icon={<IconFileUpload />}
              onClick={this.onHandlerSubmit}
              outlined
              variant="primary"
              disabled={!files.length || !transmissionType}
              className={s.submitBtn}
            >
              {t('reports.uploadTransmissionReport')}
            </Button>
          </AdaptiveDataRow>
        </FormWrapper>
      </Paper>
    );
  }
}

export default withTranslation()(UploadTransmissionReport);
